var _rect, _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDownloadCtx = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3.73333,
    fill: "#F1F1F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.5C10.5 22.857 10.5 24.0355 11.2322 24.7678C11.9645 25.5 13.143 25.5 15.5 25.5H20.5C22.857 25.5 24.0355 25.5 24.7678 24.7678C25.5 24.0355 25.5 22.857 25.5 20.5",
    stroke: "#2E2BEB",
    strokeWidth: 1.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 10.4997V21.333M18.0003 21.333L21.3337 17.6872M18.0003 21.333L14.667 17.6872",
    stroke: "#2E2BEB",
    strokeWidth: 1.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadCtx, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Download-Ctx.36457b20.svg";
export { ForwardRef as ReactComponent };